import { BODY } from './data.js';
export function hurtboxes(fighter) {
  return [{ x: fighter.x, y: fighter.y + BODY.lower, r: BODY.radius }, { x: fighter.x, y: fighter.y + BODY.upper, r: BODY.radius }];
}
/** Swept top collision prevents tunneling through thin one-way platforms. */
export function landingPlatform(stage, oldY, newY, x, dropping = false) {
  let result = null;
  for (const p of stage.platforms) {
    if (dropping && !p.solid) continue;
    if (x < p.x - p.width / 2 - BODY.radius * 0.4 || x > p.x + p.width / 2 + BODY.radius * 0.4) continue;
    if (oldY >= p.y - 0.025 && newY <= p.y && (!result || p.y > result.y)) result = p;
  }
  return result;
}
export function outsideBlastZone(f, stage) {
  const b = stage.blast;
  return f.x < b.left || f.x > b.right || f.y < b.bottom || f.y > b.top;
}
